import React from 'react';
import { compose } from 'redux';
import DashboardTemplate from 'components/templates/Dashboard';
import HeaderContainer from 'containers/HeaderContainer';
import PageQuery from 'hoc/PageQuery';
import PageView from 'hoc/PageView';
import PageTitle from 'hoc/PageTitle';
import ProtectedRoute from 'hoc/ProtectedRoute';
import PageTheme from 'hoc/PageTheme';

import DetermineLayerContainer from 'containers/dashboards/DetermineLayerContainer';
import LabsCrossChannelContainer from 'containers/labs/LabsCrossChannelContainer';
import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { SideBarObjects } from 'components/pages/config/DashboardSideBarObjects';
import showGGBrandingTheme from 'helpers/showGGBrandingTheme';

const LabCrossChannel = props => (
    <DashboardTemplate
        header={<HeaderContainer />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer entityId={parseInt(props.match.params.entityId, 10)} hideDatePicker />}>

        <DetermineLayerContainer
            layerTwo={LabsCrossChannelContainer}
            layerThree={LabsCrossChannelContainer}
            {...props} />
    </DashboardTemplate>
);

export default compose(
    ProtectedRoute(),
    PageTitle({ pageTitle: 'Labs - Multi-Channel Insights' }),
    PageView({
        page: 'Viewed Labs - Multi-Channel Insights',
        trackEntity: true,
    }),
    PageTheme({
        themeDefaults: { 'whitelabel.showGGBranding': showGGBrandingTheme },
    }),
    PageQuery({
        params: {},
        initialTruth: 'location',
    })
)(LabCrossChannel);



// WEBPACK FOOTER //
// ./src/components/pages/labs/LabCrossChannel.js